// extracted by mini-css-extract-plugin
export var active = "_c2-c";
export var compactArrow = "_c2-5";
export var container = "_c2-0";
export var dot = "_c2-b";
export var dotContainer = "_c2-a";
export var hoverArrowButton = "_c2-7";
export var hoverArrowContainer = "_c2-6";
export var leftHoverArrowContainer = "_c2-8 _c2-6";
export var rightHoverArrowContainer = "_c2-9 _c2-6";
export var slide = "_c2-4";
export var sliderContainer = "_c2-1";
export var sliderContainerVisibleOverflow = "_c2-2";
export var sliderOverflow = "_c2-3";
export var vignetteBoth = "_c2-f";
export var vignetteLeft = "_c2-e";
export var vignetteRight = "_c2-d";